export default "__VITE_ASSET__DwAHy_2R__"